import localforage from "localforage";

export async function clearAllLocFor(): Promise<void> {
  await localforage.clear();
}
